export const enNums = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
export const faNums = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
export const arNums = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

export const enDigitsRegex = /[0-9]/g;
export const faDigitsRegex = /[۰۱۲۳۴۵۶۷۸۹]/g;
export const arDigitsRegex = /[٠١٢٣٤٥٦٧٨٩]/g;
